module.exports = __webpack_public_path__ + "media/images/phone-8bddba55e0367d263a1c8d5875ac4242.png";